/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowDownward: {
  name: 'arrow-downward';
  data: string;
} = {
  name: 'arrow-downward',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/></svg>`
};
